export default {"src":"/_next/static/media/googlepodcasts-ico.5e5a5502.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};